import { APIResponse } from '@/types';
import { StoreOverviewResponse } from '@/types/pages/storeManagement/overview';
import httpService from '../httpService';

export function fetchStoreOverviewAPI(storeId: number): APIResponse<StoreOverviewResponse> {
    return httpService.get(`/store/${storeId}/overview`);
}
